module.exports = __webpack_public_path__ + "static/media/arrow-right.32e25f5b.svg";